if (!customElements.get('vat-toggle')) {
  class VatToggle extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('[data-vat-value]');
      this.storageKey = 'enterprise-vat-display';
      this.current = this.getStoredPreference();

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.setPreference(button.dataset.vatValue));
      });

      this.applyPreference(this.current);
    }

    getStoredPreference() {
      try {
        return localStorage.getItem(this.storageKey) === 'ex' ? 'ex' : 'inc';
      } catch (e) {
        return 'inc';
      }
    }

    setPreference(value) {
      this.current = value === 'ex' ? 'ex' : 'inc';

      try {
        localStorage.setItem(this.storageKey, this.current);
      } catch (e) {
        // Local storage can be unavailable in private browsing modes.
      }

      this.applyPreference(this.current);
    }

    applyPreference(value) {
      document.documentElement.dataset.vatDisplay = value;

      this.buttons.forEach((button) => {
        const isActive = button.dataset.vatValue === value;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      VatToggle.updatePrices(value);
    }

    static updatePrices(value = VatToggle.getDocumentPreference()) {
      document.querySelectorAll('[data-vat-inc][data-vat-ex]').forEach((price) => {
        const nextValue = value === 'ex' ? price.dataset.vatEx : price.dataset.vatInc;
        if (nextValue !== undefined && price.innerHTML !== nextValue) price.innerHTML = nextValue;
      });

      document.querySelectorAll('.js-vat-label').forEach((label) => {
        const nextLabel = value === 'ex' ? 'Ex VAT' : 'Inc VAT';
        if (label.textContent !== nextLabel) label.textContent = nextLabel;
      });
    }

    static getDocumentPreference() {
      return document.documentElement.dataset.vatDisplay === 'ex' ? 'ex' : 'inc';
    }
  }

  customElements.define('vat-toggle', VatToggle);

  const applyCurrentVatPreference = () => VatToggle.updatePrices();

  document.addEventListener('on:variant:before-replace-element', () => {
    requestAnimationFrame(applyCurrentVatPreference);
  });

  document.addEventListener('DOMContentLoaded', applyCurrentVatPreference);

  if ('MutationObserver' in window) {
    const observer = new MutationObserver(() => {
      clearTimeout(window.themeVatToggleTimeout);
      window.themeVatToggleTimeout = setTimeout(applyCurrentVatPreference, 0);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
}
